const data = {
    namespaced:true,//注意 模块化管理数据请不要忘了命名空间的开启
    state: {
        processOps:{}, // 正在进行的操作列表，包括timesid号等,充值订单的定时器，不同的充值订单需要不同的定时器去查询相关的状态
    },
    mutations: {
        // 更新操作进度
        setProcessOps: (state, processOps) => {
            state.processOps = processOps;
        },
    }
}

export default data